export const company = {
  name: 'Brugge Retail NV',
  storeName: 'Brugge Retail',
  street: 'Blankenbergse Steenweg 420',
  city: '8000 Brugge',
  country: 'Belgium',
  email: 'info@nvbrugge.com',
  phone: '+32 532 818 08',
  phoneHref: '+3253281808',
  enterpriseNumber: '0893.621.903',
  vatNumber: 'BE0893621903',
  foundedYear: 2007,
  yearsOfService: new Date().getFullYear() - 2007,
}
